import { BusinessRules } from "./BusinessRules";
import { Report } from "./Report";
import { Schema } from "./Schema";

export enum ValidationReportStatus {
  VALID = "VALID",
  INVALID = "INVALID",
  PENDING = "PENDING",
  FAILED = "FAILED",
}

export class ValidationReportSummary {
  private static PENDING_TEXT = "Validation is still running: please be patient.";
  datasetName: string = "";
  datasetChecksum: string = "";
  versionCode: string = "";
  userId: string = "";
  username: string = "";
  taskId: string = "";
  date: string = "";
  validationReportStatus: ValidationReportStatus;
  schemaList: Schema[] = [];
  bizRuleList: BusinessRules[] = [];
  reportList: Report[] = [];
  valid: boolean = false;

  constructor(init?: Partial<ValidationReportSummary>) {
    Object.assign(this, init);
  }

  static parse(data: any): ValidationReportSummary {
    return new ValidationReportSummary({
      datasetName: data.datasetName ?? "",
      datasetChecksum: data.datasetChecksum ?? "",
      versionCode: data.versionCode ?? "",
      userId: data.userId ?? "",
      username: data.username ?? "",
      taskId: data.taskId ?? "",
      date: data.date ?? "",
      validationReportStatus: data.validationReportStatus ?? "PENDING",
      schemaList: (data.schemaList ?? []).map((s: any) => Schema.parse(s)),
      bizRuleList: (data.bizRuleList ?? []).map((b: any) => BusinessRules.parse(b)),
      reportList: (data.reportList ?? [{ errorMessage: data.Status ?? this.PENDING_TEXT }]).map((r: any) =>
        Report.parse(r)
      ),
      valid: data.valid ?? false,
    });
  }
}
